import { useTranslation } from 'react-i18next';

// PRD 03 §3.8 (v1.3) — secondary chip rendered next to the status badge when
// the row has a pending self-withdraw request. Color follows the prototype
// (institution-managers.html L349): red-toned (#fee2e2 / #b91c1c).
export function WithdrawRequestChip() {
  const { t } = useTranslation('admin');
  return (
    <span
      className="badge"
      style={{
        background: '#fee2e2',
        color: '#b91c1c',
        minWidth: 'auto',
        marginLeft: 'var(--space-2)',
      }}
    >
      {t('medicalStaffManagement.withdrawRequest.chip')}
    </span>
  );
}
